<!-- 查看公钥弹窗 -->
<template>
  <el-dialog
    class="see-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="20vh"
  >
    <detail-section :show-title="false" :show-border="true">
      <div class="info-content">{{ content }}</div>
    </detail-section>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleOk()">下载</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SeeDialog',
  data() {
    return {
      title: '',
      dialogVisible: false,
      content: '',
      data: {}
    }
  },
  methods: {
    handleCancel() {
      this.content = ''
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.data = data
      this.content = data.cert
      this.title = data.title
      this.dialogVisible = true
    },
    handleOk() {
      const name = this.title + '.key'
      this.$utils.createFileAndDownload(name, this.content)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.see-cert-dialog.common-dialog {
  @include adaptation(
    (
      --see-cert-dialog-width: 800px,
      --see-cert-dialog-info-content-item-small-max-height: 280px,
      --see-cert-dialog-info-content-item-max-height: 480px,
      --see-cert-dialog-info-content-padding: 24px,
      --see-cert-dialog-info-content-line-height: 27px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .info-content {
    max-height: var(--see-cert-dialog-info-content-item-max-height);
    padding: var(--see-cert-dialog-info-content-padding);
    overflow-y: auto;
    line-height: var(--see-cert-dialog-info-content-line-height);
  }
}
</style>
